// Строка знакомства в карточке репетитора (карта /tutors и /tutors/<slug>).
//
// Показываем, когда занятие идёт у ученика дома или это помощь с домашним
// заданием: родителю полезно увидеть человека до первого занятия.
//   · есть выезд к ученику — непустой travel_districts. Условие строим именно
//     по районам выезда, а не по address_mode: выезд появится и у «Моё
//     здание», и строка должна показаться и там;
//   · или среди предметов есть услуга homework.
// Только у репетитора: у кружка строки нет.
//
// Строка — приглашение познакомиться, не обещание. Никаких «проверено»,
// «безопасно» и подобного: мы этого не проверяем (scripts/verify-map-meet-line.mts).
import type { SiteLang } from "@/components/site/SiteChrome";
import type { PublicPartner } from "@/lib/map-public.functions";

export const MEET_LINE: Record<SiteLang, string> = {
  ru: "Познакомьтесь с репетитором до первого занятия",
  az: "İlk dərsdən əvvəl repetitorla tanış olun",
  en: "Meet the tutor before the first lesson",
};

/** Код услуги «Помощь с домашним заданием» в map-taxonomy.json. */
export const HOMEWORK_CODE = "homework";

export function showMeetLine(p: Pick<PublicPartner, "kind" | "travel_districts" | "subjects">): boolean {
  if (p.kind !== "tutor") return false;
  return (p.travel_districts?.length ?? 0) > 0 || (p.subjects ?? []).includes(HOMEWORK_CODE);
}
